import React from 'react';
import Input from '../../../components/ui/Input';

function ContentfulSourceFields({ values, onFieldChange, onCheckboxChange }) {
  return (
    <div className="space-y-4 rounded-xl border border-surface-border bg-slate-50/60 p-4">
      <Input
        id="kb_contentful_space_id"
        label="Space ID"
        value={values.spaceId}
        onChange={onFieldChange('spaceId')}
        placeholder="abc123xyz"
        required
      />
      <Input
        id="kb_contentful_environment"
        label="Environment"
        value={values.environment}
        onChange={onFieldChange('environment')}
        placeholder="master"
        required
      />
      <Input
        id="kb_contentful_api_url"
        label="URL da API"
        value={values.apiUrl}
        onChange={onFieldChange('apiUrl')}
        placeholder="https://cdn.contentful.com"
        required
      />
      <Input
        id="kb_contentful_access_token"
        label="Delivery Token"
        type="password"
        value={values.accessToken}
        onChange={onFieldChange('accessToken')}
        required
        autoComplete="new-password"
      />
      <Input
        id="kb_contentful_locale"
        label="Locale"
        value={values.locale}
        onChange={onFieldChange('locale')}
        placeholder="*"
      />
      <Input
        id="kb_contentful_content_types"
        label="Content Types (opcional)"
        value={values.contentTypes}
        onChange={onFieldChange('contentTypes')}
        placeholder="article, faq"
      />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={values.includeAssets}
            onChange={(event) => onCheckboxChange('includeAssets', event.target.checked)}
          />
          Importar assets (PDF, DOC, DOCX)
        </label>
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={values.includeEntries}
            onChange={(event) => onCheckboxChange('includeEntries', event.target.checked)}
          />
          Importar entries (texto / rich text)
        </label>
      </div>
    </div>
  );
}

export default ContentfulSourceFields;
